// extracted by mini-css-extract-plugin
export default {"wrapper":"GainChartCustomTooltip_wrapper__Rrccp"};